import styled from 'styled-components'

export const ContainerPontos = styled.div`
  width: 100%;
  height: 100%;
  margin-bottom: 10px;

  .points-title {
    color: #757575;
    font-size: 13px;
    font-weight: 700;
    margin-top: 10px;
    margin-bottom: 10px;
  }

  .points-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, 32px);
    gap: 5px;
    /* Pula render/layout dos chips fora da tela (muitos pontos x muitas análises). */
    /* content-visibility: auto;
    contain-intrinsic-size: auto 90px; */
  }

  .point-card {
    background-color: #eef2ff;
    color: white;
    font-weight: 700;
    font-size: 13px;
    width: 32px;
    max-width: 32px;
    max-width: 32px;
    height: 32px;
    border-radius: 8px;
    position: relative;
    cursor: default;

    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 10px;
    transition: opacity 0.2s;
  }

  .point-card:hover {
    opacity: 0.85;
  }

  .point-card__remove {
    position: absolute;
    top: -6px;
    right: -6px;
    width: 18px;
    height: 18px;
    border-radius: 50%;
    background-color: #ff4d4f;
    color: white;
    border: 2px solid white;
    font-size: 10px;
    font-weight: bold;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    opacity: 0;
    transform: scale(0.5);
    transition: opacity 0.15s ease, transform 0.15s ease;
    pointer-events: none;
    padding: 0;
    line-height: 1;
  }

  .point-card:hover .point-card__remove {
    opacity: 1;
    transform: scale(1);
    pointer-events: auto;
  }

  .point-card__remove:hover {
    background-color: #cf1322;
  }
`
